import template from './realizations.html';

export default realizationsConfig;

/** @ngInject */
function realizationsConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Wykaz zajęć',
    state: 'modules.realizations.byEmployee',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.realizations', {
      url: '/realizations',
      abstract: true,
      views: {
        'content@': {
          template,
          controller: 'RealizationsController as ctrl'
        }
      },
      resolve: {
        me: SchoolCommonRoomService => SchoolCommonRoomService.getMe()
      }
    })
    .state('modules.realizations.byEmployee', {
      url: '/byEmployee',
      views: {
        'realizations@modules.realizations': {
          component: 'realizationsComponent'
        }
      },
      resolve: {
        substitutions: (SubstitutionService, currentSchoolCommonRoom, me) => SubstitutionService.getAll({
          schoolCommonRoomIds: [currentSchoolCommonRoom.id],
          substituteTeacherIds: [me.userId]
        }, true)
      }
    })
    .state('modules.realizations.byGroup', {
      url: '/byGroup',
      views: {
        'realizations@modules.realizations': {
          component: 'realizationsByGroupComponent'
        }
      },
      resolve: {
        groups: GroupService => GroupService.getAllGroups()
      }
    })
    .state('modules.realizations.byTeacher', {
      url: '/byTeacher',
      views: {
        'realizations@modules.realizations': {
          component: 'realizationsByTeacherComponent'
        }
      },
      resolve: {
        teachers: EmployeeService => EmployeeService.getSchoolCommonRoomEmployees()
      }
    })
    .state('modules.realizations.add', {
      url: '/add',
      data: {
        title: 'Dodaj wpis',
        displayName: 'Dodaj wpis'
      },
      views: {
        'realizations@modules.realizations': {
          component: 'addRealizationComponent'
        }
      }
    })
    .state('modules.realizations.addBySubstitution', {
      url: '/add-substitution/:activityId',
      params: {
        activityId: null
      },
      data: {
        title: 'Dodaj realizację z zastępstwa',
        displayName: 'Dodaj realizację z zastępstwa'
      },
      views: {
        'realizations@modules.realizations': {
          component: 'addSubstitutionRealizationComponent'
        }
      },
      resolve: {
        substitution: (SubstitutionService, $stateParams) => {
          return SubstitutionService.getActivity(
            $stateParams.activityId
          );
        }
      }
    })
    .state('modules.realizations.edit', {
      url: '/edit/:id',
      data: {
        title: 'Edytuj wpis',
        displayName: 'Edytuj wpis'
      },
      views: {
        'realizations@modules.realizations': {
          component: 'editRealizationComponent'
        }
      },
      resolve: {
        realization: (RealizationService, $stateParams) => {
          return RealizationService.get($stateParams.id);
        }
      }
    })
    .state('modules.realizations.editBySubstitution', {
      url: '/edit-substitution/:id',
      data: {
        title: 'Edytuj wpis z zastępstwa',
        displayName: 'Edytuj wpis z zastępstwa'
      },
      views: {
        'realizations@modules.realizations': {
          component: 'editSubstitutionRealizationComponent'
        }
      },
      resolve: {
        realization: (RealizationService, $stateParams) => {
          return RealizationService.get($stateParams.id);
        }
      }
    });
}
